/**
 * Decide whether a failed API response should trigger a full-page /forbidden redirect.
 * Stale super-admin requests after switching into a tenant session must not hijack navigation.
 */
export const shouldRedirectToForbidden = (error, config = {}) => {
  if (config?.skipForbiddenRedirect === true) {
    return false
  }

  const requestUrl = String(
    config?.url || error?.config?.url || error?.response?.config?.url || ""
  )

  if (requestUrl.includes("superadmin/")) {
    return false
  }

  if (
    typeof sessionStorage !== "undefined" &&
    sessionStorage.getItem("tenantLoginRedirect") === "1"
  ) {
    return false
  }

  return true
}

export const beginTenantLoginRedirect = () => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem("tenantLoginRedirect", "1")
  }
}

export const completeTenantLoginRedirect = () => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem("tenantLoginRedirect")
  }
}
